import { KYMW0800OutputModel } from './../../../../commons/kymw08/kymw0800/vo/kymw0800-output.model';
import { Component, ViewEncapsulation, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output, ViewContainerRef } from '@angular/core';
import { KYMW00Model } from '../../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../../commons/kymw00/pless-view-helper-sub';
import { KYMW1300Model } from '../kymw1300.model';
import { KYMW1300SelectedListModel } from '../vo/kymw1300-selected-list.model';
import { KYMW1308Component } from '../../kymw1308/kymw1308.component';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW0400Component } from '../../../../commons/kymw04/kymw0400/kymw0400.component';
import { KYMW0400InputModel } from '../../../../commons/kymw04/kymw0400/vo/kymw0400-input.model';
import { KYMW0400OutputModel } from '../../../../commons/kymw04/kymw0400/vo/kymw0400-output.model';
import { OutputSelectedListService } from '../api-services/output-selected-list.service';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW0900Component } from '../../../../commons/kymw09/kymw0900/kymw0900.component';
import { KYMW1310Component } from '../../kymw1310/kymw1310.component';
import { KYMW1307Component } from '../../kymw1307/kymw1307.component';
import { KYMW0800Component } from '../../../../commons/kymw08/kymw0800/kymw0800.component';
import { KYMW0500Component } from '../../../../commons/kymw05/kymw0500/kymw0500.component';
import { KYMW1317Component } from '../../kymw1317/kymw1317.component';
import { OutputSpecConfirmListService } from '../api-services/output-spec-confirm-list.service';
import { FlexGrid, CellType, CellRange } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';
import { ClassCodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import { MiddleClassCodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/middle-class-code-combo-box/middle-class-code-combo-box.component';
import { SmallClassCodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component';
import { PageComboBoxComponent } from '../../../../commons/kymw02/combo-box/page-combo-box/page-combo-box.component';
import { CodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { OrderNumQuotaCodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/order-num-quota-code-combo-box/order-num-quota-code-combo-box.component';
import { KYMW1308InputModel } from '../../kymw1308/vo/kymw1308-input.model';
import { KYMW1308OutputModel } from '../../kymw1308/vo/kymw1308-output.model';
import { GetSelectedListService } from '../api-services/get-selected-list.service';
import { KYMW1300GetSearchSelectedListModel } from '../vo/kymw1300-get-search-selected-list.model';
import { CoopCodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/coop-code-combo-box/coop-code-combo-box.component';
import { KYMW1310InputModel } from '../../kymw1310/vo/kymw1310-input.model';
import { KYMW1312InputModel } from '../../kymw1312/vo/kymw1312-input.model';
import { KYMW0800InputModel } from '../../../../commons/kymw08/kymw0800/vo/kymw0800-input.model';
import { Point } from '@grapecity/wijmo';
import { KYMW0500InputModel } from '../../../../commons/kymw05/kymw0500/vo/kymw0500-input.model';
import { KYMW0500OutputModel } from '../../../../commons/kymw05/kymw0500/vo/kymw0500-output.model';
import { RadioLabelComponent } from '../../../../commons/kymw02/radio-label/radio-label.component';
import { KYMW1307InputModel } from '../../kymw1307/vo/kymw1307-input.model';
import { UpdateNextGuideLumpService } from '../api-services/update-next-guide-lump.service';
import { UpdateNextGuideAutoService } from '../api-services/update-next-guide-auto.service';
import { KYMW1300UpdateNextGuideAutoModel } from '../vo/kymw1300-update-next-guide-auto.model';
import { KYMW1300DeletePlanModel } from '../vo/kymw1300-delete-plan.model';
import { CheckDeletePlanService } from '../api-services/check-delete-plan.service';
import { KYMW1312Component } from '../../kymw1312/kymw1312.component';
import { PlessAlert } from '../../../../shared/pless-alert/pless-alert.component';
import { KYMW1312OutputModel } from '../../kymw1312/vo/kymw1312-output.model';
import { KYMW0900InputModel } from '../../../../commons/kymw09/kymw0900/vo/kymw0900-input.model';
import { KYMW0900OutputModel } from '../../../../commons/kymw09/kymw0900/vo/kymw0900-output.model';
import { DataGridUtil } from '../../../../commons/kymw00/data-grid-util';
import { PlanGoodsLockService } from '../../../../commons/kymw00/api-services/plan-goods-lock.service';
import { KYMW1317InputModel } from '../../kymw1317/vo/kymw1317-input.model';
import { KYMW1317OutputModel } from '../../kymw1317/vo/kymw1317-output.model';
import { faArrowAltCircleLeft, faArrowAltCircleRight, faSearch } from '@fortawesome/free-solid-svg-icons';
import { PagerComponent } from 'src/app/commons/kymw02/pager/pager.component';
import { KYMW1319Component } from '../../kymw1319/kymw1319.component';

/**
 * 商品企画マスタ画面　選定済一覧を管理するクラス
 *
 * @export KYMW1300SelectedListComponent
 * @class KYMW1300SelectedListComponent
 */
@Component({
  selector: 'app-kymw1300-selected-list',
  templateUrl: 'kymw1300-selected-list.component.html',
  styleUrls: ['kymw1300-selected-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1300SelectedListComponent extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  @Input() parentModel: KYMW1300Model = null;

  // 画面部品参照
  @ViewChild('cmb_OrderNumQuota_Selected', { static: true }) cmb_OrderNumQuota_Selected: OrderNumQuotaCodeComboBoxComponent;

  @ViewChild('cmb_CoopCode', { static: true }) cmb_CoopCode: CoopCodeComboBoxComponent;
  @ViewChild('lbl_ClassCode', { static: true }) lbl_ClassCode: ElementRef;
  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('lbl_MiddleClassCode', { static: true }) lbl_MiddleClassCode: ElementRef;
  @ViewChild('cmb_MiddleClassCode', { static: true }) cmb_MiddleClassCode: MiddleClassCodeComboBoxComponent;
  @ViewChild('lbl_SmallClassCode', { static: true }) lbl_SmallClassCode: ElementRef;
  @ViewChild('cmb_SmallClassCode', { static: true }) cmb_SmallClassCode: SmallClassCodeComboBoxComponent;
  @ViewChild('lbl_PageNo', { static: true }) lbl_PageNo: ElementRef;
  @ViewChild('cmb_PageNo', { static: true }) cmb_PageNo: PageComboBoxComponent;
  @ViewChild('lbl_buyerCode', { static: true }) lbl_buyerCode: ElementRef;
  @ViewChild('cmb_buyerCode', { static: true }) cmb_buyerCode: CodeComboBoxComponent;

  @ViewChild('rbtn_bumon', { static: true }) rbtn_bumon: RadioLabelComponent;
  @ViewChild('btn_bundleMixMatch', { static: true }) btn_bundleMixMatch: ElementRef;
  @ViewChild('btn_nextGuideBatchSet', { static: true }) btn_nextGuideBatchSet: ElementRef;
  @ViewChild('btn_nextGuideCheck', { static: true }) btn_nextGuideCheck: ElementRef;
  @ViewChild('btn_display', { static: true }) btn_display: ElementRef;

  @ViewChild('lbl_OrderClient', { static: true }) lbl_OrderClient: ElementRef;
  @ViewChild('tbx_OrderClientCode', { static: true }) tbx_OrderClientCode: ElementRef;
  @ViewChild('tbx_OrderClientKanji', { static: true }) tbx_OrderClientKanji: ElementRef;
  @ViewChild('btn_SearchOrderClient', { static: true }) btn_SearchOrderClient: ElementRef;

  @ViewChild('lbl_PayeeClient', { static: true }) lbl_PayeeClient: ElementRef;
  @ViewChild('tbx_PayeeClientCode', { static: true }) tbx_PayeeClientCode: ElementRef;
  @ViewChild('tbx_PayeeClientKanji', { static: true }) tbx_PayeeClientKanji: ElementRef;
  @ViewChild('btn_SearchPayeeClient', { static: true }) btn_SearchPayeeClient: ElementRef;

  @ViewChild('dg_SelectedItemList', { static: true }) dg_SelectedItemList: FlexGrid;

  @ViewChild('btn_prevDisplayList', { static: true }) btn_prevDisplayList: ElementRef;
  @ViewChild('btn_nextDisplayList', { static: true }) btn_nextDisplayList: ElementRef;

  @ViewChild('box_selected_list', { static: true }) box_selected_list: ElementRef;
  @ViewChild('cmb_DisplaySet', { static: true }) cmb_DisplaySet: ElementRef;
  @ViewChild('selectedPager', { static: true }) selectedPager: PagerComponent;

  @Output() btnSearchClick = new EventEmitter;


  /**
   * 選定済一覧
   */
  public selectedModel: KYMW1300SelectedListModel = new KYMW1300SelectedListModel();

  // コンテキストメニュー
  private cmDgKYMW1300_03: Menu;

  /**
   * 選定済一覧 項目名
   * DataGridの列名とテーブル物理名を紐付ける連想配列Object
   */
  private selectedListField: Object;

  // ページング
  iconPrev = faArrowAltCircleLeft;
  iconNext = faArrowAltCircleRight;

  /**
   * Creates an instance of KYMW1300SelectedListComponent.
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1300SelectTargetTabModel
   */
  constructor(
    private elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
    private dialogService: PlessDialogServiceSub,
    private checkDeletePlanService: CheckDeletePlanService,
    private getSelectedListService: GetSelectedListService,
    private outputSelectedListService: OutputSelectedListService,
    private outputSpecConfirmListService: OutputSpecConfirmListService,
    private updateNextGuideAutoService: UpdateNextGuideAutoService,
    private updateNextGuideLumpService: UpdateNextGuideLumpService,
    kymw00Model: KYMW00Model,
    private planGoodsLockServiceSub: PlanGoodsLockService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1300SelectedList';
    this.planGoodsLockService = this.planGoodsLockServiceSub;

    // 選定済一覧 項目名を初期化
    this.selectedListField = new Object();
    this.selectedListField['ClassCode'] = 'CLASS_CODE';
    this.selectedListField['SmallClassCode'] = 'SMALL_CLASS_CODE';
    this.selectedListField['GuideGoodsName'] = 'GUIDE_GOODS_NAME';
    this.selectedListField['GuideStandardName'] = 'GUIDE_STANDARD_NAME';
    this.selectedListField['RelateMasterCode'] = 'RELATE_MASTER_CODE';
    this.selectedListField['PCode'] = 'PCODE';
    this.selectedListField['GuideTempZoneName'] = 'GUIDE_TEMP_ZONE_NAME';
    this.selectedListField['BuyerCode'] = 'BUYER_CODE';
    this.selectedListField['ConsumeTaxDivName'] = 'CONSUME_TAX_DIV_NAME';
    this.selectedListField['ConsumeTaxRate'] = 'CONSUME_TAX_RATE';
    this.selectedListField['BuyerComment'] = 'BUYER_COMMENT';
    this.selectedListField['KikakuRenrakuStatusName'] = 'KIKAKU_RENRAKU_STATUS';

    // コンテキストメニュー初期化
    this.setContextMenu();

    this.dg_SelectedItemList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dg_SelectedItemList.select(-1, -1);

      // データグリッド行の背景色設定処理
      this.setColorPattern(this.dg_SelectedItemList);
    });
    // 企画連絡セルの背景色設定
    this.setKikakuRenrakuCellStyle(this.dg_SelectedItemList);

    this.selectedModel.kymw1300Component = this.parentModel.kymw1300Component;
    this.selectedModel.kymw1300_03Cmp = this;

    this.eventDispMode_CLICKHandler();
  }

  /**
   * データグリッド行の背景色設定
   *
   * @param grid 処理対象データグリッド
   */
  public setColorPattern(grid: FlexGrid): void {

    let rowIndex: number = <number>0;                                           // 行インデックス

    // 背景色設定
    grid.rows.forEach((row) => {
      // 状態のチェック(0：通常、1：仮登録、2：自媒体選定、3：他媒体選定、9：取扱期間外)
      if (row.dataItem.Status === '1') {                                        // 「1：仮登録」の場合
        row.cssClass = 'grid-row-temporary-registration';
      } else if (row.dataItem.Status === '9') {                                 // 「9：取扱期間外」の場合
        row.cssClass = 'grid-row-outside-handling-period';
      } else if (rowIndex % 2 === 1) {                                          // 奇数行の場合
        row.cssClass = 'grid-row-normal-odd';
      } else {                                                                  // 上記以外の場合
        row.cssClass = 'grid-row-normal-even';
      }

      // 行インデックスを加算
      rowIndex++;
    });
  }

  /**
   * 企画連絡セルの背景色設定
   *
   * @private
   * @param {FlexGrid} grid
   * @memberof KYMW1300SelectedListComponent
   */
  private setKikakuRenrakuCellStyle(grid: FlexGrid): void {
    grid.itemFormatter = (panel, r, c, cell) => {
      if (panel.cellType === CellType.Cell) {
        // スクロール時に他のセルのスタイルが適用されるバグがwijmoにある為、一度初期化する
        cell.style.backgroundColor = '';
        if (panel.columns[c].binding === 'KikakuRenrakuStatusName') {
          cell.style.backgroundColor = `rgba(${panel.rows[r].dataItem.KikakuRenrakuStatusBgColor})`;
        }
      }
    };
  }

  /**
   * コンテキストメニュー初期化
   *
   * @memberof KYMW1300SelectedListComponent
   */
  private setContextMenu(): void {
    const item_01: any = { header: '商品企画メンテナンス', caption: '商品企画メンテナンス', cmd: 'KYMW0900', enabled: true };
    const item_04: any = { header: '紐付設定', caption: '紐付設定', cmd: 'KYMW0500', enabled: true };
    const item_05: any = { header: 'バンドルミックスマッチ設定', caption: 'バンドルミックスマッチ設定', cmd: 'KYMW1308_MOD', enabled: true };
    const item_06: any = { header: 'セット企画設定', caption: 'セット企画設定', cmd: 'KYMW1312_MOD', enabled: true };
    const item_07: any = { header: 'Ｗ掲載設定', caption: 'Ｗ掲載設定', cmd: 'KYMW1310', enabled: true };
    const item_08: any = { header: 'バンドルミックスマッチに追加', caption: 'バンドルミックスマッチに追加', cmd: 'KYMW1308_ADD', enabled: true };
    const item_09: any = { header: 'セット企画に追加', caption: 'セット企画に追加', cmd: 'KYMW1312_ADD', enabled: true };
    const item_10: any = { header: '次回案内自動設定', caption: '次回案内自動設定', cmd: 'NextGuideSet', enabled: true };
    const item_11: any = { header: '履歴', caption: '履歴', cmd: 'KYMW0800Selected', enabled: true };
    const item_12: any = { header: '予算・計画・実績表', caption: '予算・計画・実績表', cmd: 'KYMW1307', enabled: true };
    const item_13: any = { header: '仕様確認表出力', caption: '仕様確認表出力', cmd: 'OutputSpecConfirmList', enabled: true };
    const item_14: any = { header: '選定解除', caption: '選定解除', cmd: 'DeletePlan', enabled: true };
    const item_15: any = { header: '企画連絡承認', caption: '企画連絡承認', cmd: 'KYMW1317', enabled: true };
    const item_16: any = { header: '特集付替設定', caption: '特集付替設定', cmd: 'KYMW1319', enabled: true };

    this.cmDgKYMW1300_03 = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          item_15,
          item_01,
          { header: '-', caption: '-' },
          item_04,
          item_05,
          item_06,
          item_07,
          item_16,
          { header: '-', caption: '-' },
          item_08,
          item_09,
          { header: '-', caption: '-' },
          item_10,
          { header: '-', caption: '-' },
          item_11,
          { header: '-', caption: '-' },
          item_12,
          { header: '-', caption: '-' },
          item_13,
          { header: '-', caption: '-' },
          item_14,
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: () => {
          switch (this.cmDgKYMW1300_03.selectedValue) {
            case 'KYMW0900':                                                    // 商品企画修正
              this.eventKYMW0900_CLICKHandler();
              break;
            case 'KYMW0500':                                                    // 紐付設定
              this.eventKYMW0500_CLICKHandler();
              break;
            case 'KYMW1308_MOD':                                                // バンドルミックスマッチ設定
              this.eventKYMW1308_MOD_CLICKHandler();
              break;
            case 'KYMW1312_MOD':                                                // セット企画設定
              this.eventKYMW1312_MOD_CLICKHandler();
              break;
            case 'KYMW1310':                                                    // Ｗ掲載設定
              this.eventKYMW1310_CLICKHandler();
              break;
            case 'KYMW1308_ADD':                                                // バンドルミックスマッチに追加
              this.eventKYMW1308_ADD_CLICKHandler();
              break;
            case 'KYMW1312_ADD':                                                // セット企画に追加
              this.eventKYMW1312_ADD_CLICKHandler();
              break;
            case 'NextGuideSet':                                                // 次回案内自動設定
              this.eventNextGuideSet_CLICKHandler();
              break;
            case 'KYMW0800Selected':                                            // 履歴
              this.eventKYMW0800Selected_CLICKHandler();
              break;
            case 'KYMW1307':                                                    // 予算・計画・実績表
              this.eventKYMW1307_CLICKHandler();
              break;
            case 'OutputSpecConfirmList':                                       // 仕様確認表出力
              this.eventOutputSpecConfirmList_CLICKHandler();
              break;
            case 'DeletePlan':                                                  // 選定解除
              this.eventDeletePlan_CLICKHandler();
              break;
            case 'KYMW1317':                                                    // 企画連絡承認
              this.eventKYMW1317_CLICKHandler();
              break;
            case 'KYMW1319':                                                    // 特集付替設定
              this.eventKYMW1319_CLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dg_SelectedItemList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.cmDgKYMW1300_03 !== undefined) {
        const ht = this.dg_SelectedItemList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 選択した行がすでに選択されていない行の場合はその行を選択（既に選択されている行はクリア）
          const alreadySelectedRow = this.dg_SelectedItemList.selectedRows.filter(row => row.index === ht.row);
          if (PlessViewUtilsSub.isEmptyArray(alreadySelectedRow)) {
            // 右クリック押下時に対象行を選択状態にする
            const grid = new CellRange(ht.row, ht.col);
            this.dg_SelectedItemList.select(grid, false);
          }
          // コンテキストメニューの活性・非活性制御
          this.eventContextMenuSelected_Handler(this.cmDgKYMW1300_03);
          this.cmDgKYMW1300_03.show(e);
        } else {
          // コンテキストメニュー活性・非活性制御
          this.cmDgKYMW1300_03.itemsSource.forEach(item => {
            item.enabled = false;
          });
          this.cmDgKYMW1300_03.show(e);
        }
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(item_01, 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_04, 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_05, 'false');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_06, 'false');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_07, 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_08, 'false');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_09, 'false');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_10, 'false');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_11, 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_12, 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_13, 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_14, 'false');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_15, 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(item_16, 'none');
  }

  /**
   * コンテキストメニュー活性・非活性制御
   *
   * @private
   * @param {Menu} contextMenu
   * @returns {void}
   * @memberof KYMW1300SelectedListComponent
   */
  public eventContextMenuSelected_Handler(contextMenu: Menu): void {
    let enableFlag = Boolean(true);
    const grid: FlexGrid = this.dg_SelectedItemList;

    // 選択行のチェック
    if (grid === null || grid.selection.row === -1) {                           // 選択行なしの場合
      // コンテキストメニュー活性・非活性制御
      contextMenu.itemsSource.forEach(item => {
        item.enabled = this.setContextMenuEnabled(item, false);
      });

      this.parentModel.targetPCode = '';

      // 処理復帰
      return;
    }

    const mediumType: string = this.parentModel.mediumType;
    const pCode: string = this.dg_SelectedItemList.selectedItems[0].PCode;
    const status: string = this.dg_SelectedItemList.selectedItems[0].Status;
    const kikakuRenrakuStatus: string = this.dg_SelectedItemList.selectedItems[0].KikakuRenrakuStatus;

    this.parentModel.targetPCode = pCode;

    // コンテキストメニュー活性・非活性制御
    contextMenu.itemsSource.forEach(item => {
      enableFlag = true;

      if (item.caption === '選定解除') {
        // 編集ロックのチェック
        if (!this.parentModel.editLock) {                                       // 「false：閲覧モード」の場合
          enableFlag = false;
        }
        // 媒体区分のチェック
        if (PlessViewUtilsSub.isEmpty(mediumType)) {                            // 未選択の場合
          enableFlag = false;
        }
        // バンドルミックスマッチ設定画面起動状況のチェック
        if (this.isOpened('KYMW1308')) {                                        // 起動中の場合
          enableFlag = false;
        }
        // セット企画設定画面起動状況のチェック
        if (this.isOpened('KYMW1312')) {                                        // 起動中の場合
          enableFlag = false;
        }
      } else if (item.caption === '次回案内自動設定') {
        // 編集ロックのチェック
        if (!this.parentModel.editLock) {                                       // 「false：閲覧モード」の場合
          enableFlag = false;
        }
        // 媒体区分のチェック
        if (!this.parentModel.isDutiesFormWeeklyOrDivPeriod()) {                // ウィークリーでもいつでも注文でもない場合
          enableFlag = false;
        }
      } else if (item.caption === 'バンドルミックスマッチ設定') {
        // プロモーション情報のチェック
        if (!this.parentModel.hasPromotionInfo(pCode)) {                        // プロモーション情報なしの場合
          enableFlag = false;
        }
        // 媒体区分のチェック
        if (!this.parentModel.isDutiesFormWeekly()) {                           // ウィークリーでない場合
          enableFlag = false;
        }
      } else if (item.caption === 'セット企画設定') {
        // セット企画プロモーション情報のチェック
        if (!this.parentModel.hasSetPromotionInfo(pCode)) {                     // セット企画プロモーション情報なしの場合
          enableFlag = false;
        }
        // 媒体区分のチェック
        if (!this.parentModel.isDutiesFormWeekly()) {                           // ウィークリーでない場合
          enableFlag = false;
        }
      } else if (item.caption === 'バンドルミックスマッチに追加') {
        // 編集ロックのチェック
        if (!this.parentModel.editLock) {                                       // 「false：閲覧モード」の場合
          enableFlag = false;
        }
        // バンドルミックスマッチ設定画面起動状況のチェック
        if (!this.isOpened('KYMW1308')) {                                        // 未起動の場合
          enableFlag = false;
        }
        // セット企画設定画面起動状況のチェック
        if (this.isOpened('KYMW1312')) {                                        // 起動中の場合
          enableFlag = false;
        }
        // 媒体区分のチェック
        if (!this.parentModel.isDutiesFormWeekly()) {                           // ウィークリーでない場合
          enableFlag = false;
        }
      } else if (item.caption === 'セット企画に追加') {
        // 編集ロックのチェック
        if (!this.parentModel.editLock) {                                       // 「false：閲覧モード」の場合
          enableFlag = false;
        }
        // バンドルミックスマッチ設定画面起動状況のチェック
        if (this.isOpened('KYMW1308')) {                                        // 起動中の場合
          enableFlag = false;
        }
        // セット企画設定画面起動状況のチェック
        if (!this.isOpened('KYMW1312')) {                                        // 未起動の場合
          enableFlag = false;
        }
        // 媒体区分のチェック
        if (!this.parentModel.isDutiesFormWeekly()) {                           // ウィークリーでない場合
          enableFlag = false;
        }
      } else if (item.caption === '紐付設定') {
        // ステータスのチェック
        if (status === '1') {                                                   // 「1：仮登録」の場合場合
          enableFlag = false;
        }
      } else if (item.caption === 'Ｗ掲載設定') {
        // 編集ロックのチェック
        if (!this.parentModel.editLock) {                                       // 「false：閲覧モード」の場合
          enableFlag = false;
        }
        // 媒体区分のチェック
        if (!this.parentModel.isDutiesFormWeekly()) {                           // ウィークリーでない場合
          enableFlag = false;
        }
      } else if (item.caption === '企画連絡承認') {
        // 企画連絡承認画面起動状況のチェック
        const disableStatusList = [null, ``, '-1', '0', '1', '2', '8', '9', '15', '16'];
        if (this.isOpened('KYMW1317')) {                                        // 起動中の場合
          enableFlag = false;
        } else if (disableStatusList.some(disableStatus => kikakuRenrakuStatus === disableStatus)) { //企画連絡ステータスが非活性ステータスの場合
          enableFlag = false;
        }
      } else if (item.caption === '特集付替設定') {
        // 媒体区分のチェック
        if (PlessViewUtilsSub.isEmpty(mediumType)) {                            // 媒体未選択の場合
          enableFlag = false;
        }
      }

      // コンテキストメニュー活性・非活性制御
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        if (param.enabled === false) {
          return false;
        } else {
          return true;
        }
      }
    };
  }

  /**
   * 表示モード(ラジオボタン)_クリック時に呼び出されるメソッド
   *
   * @private
   * @memberof KYMW1300SelectedListComponent
   */
  public eventDispMode_CLICKHandler(): void {
    // 表示モードの切り替え処理
    this.setDispMode(this.selectedModel.dispMode);
  }

  /**
   * 表示モードの切り替えを行う
   *
   * @param {string} [value=''] 表示モード(1：部門、2：ページ、3：バイヤー)
   * @memberof KYMW1300SelectedListComponent
   */
  public setDispMode(value = ''): void {
    // 入力パラメータの表示モードのチェック
    if (!PlessViewUtilsSub.isEmpty(value)) {                                      // 指定ありの場合
      this.selectedModel.dispMode = value;
    }

    // 表示モードのチェック
    switch (this.selectedModel.dispMode) {
      case '1':                                                                   // 「1：部門」の場合
        this.lbl_ClassCode.nativeElement.style.display = '';                      // 部門ラベル
        this.cmb_ClassCode.elementRef.nativeElement.style.display = '';           // 部門コンボ
        this.lbl_MiddleClassCode.nativeElement.style.display = '';                // 中分類ラベル
        this.cmb_MiddleClassCode.elementRef.nativeElement.style.display = '';     // 中分類コンボ
        this.lbl_SmallClassCode.nativeElement.style.display = '';                 // 小分類ラベル
        this.cmb_SmallClassCode.elementRef.nativeElement.style.display = '';      // 小分類コンボ
        this.lbl_PageNo.nativeElement.style.display = 'none';                     // ページNOラベル
        this.cmb_PageNo.elementRef.nativeElement.style.display = 'none';          // ページNOコンボ
        this.lbl_buyerCode.nativeElement.style.display = 'none';                  // バイヤーコードラベル
        this.cmb_buyerCode.elementRef.nativeElement.style.display = 'none';       // バイヤーコード
        this.lbl_OrderClient.nativeElement.style.display = '';                    // 発注先ラベル
        this.tbx_OrderClientCode.nativeElement.style.display = '';                // 発注先取引先コードテキスト
        this.tbx_OrderClientKanji.nativeElement.style.display = '';               // 発注先取引先名称テキスト
        this.btn_SearchOrderClient.nativeElement.style.display = '';              // 発注先検索ボタン
        this.lbl_PayeeClient.nativeElement.style.display = '';                    // 支払先ラベル
        this.tbx_PayeeClientCode.nativeElement.style.display = '';                // 支払先取引先コードテキスト
        this.tbx_PayeeClientKanji.nativeElement.style.display = '';               // 支払先取引先名称テキスト
        this.btn_SearchPayeeClient.nativeElement.style.display = '';              // 支払先検索ボタン
        this.selectedModel.kikakuRenrakuStatus = '';                              // 企画連絡ステータス
        break;
      case '2':                                                                   // 「2：ページ」の場合
        this.lbl_ClassCode.nativeElement.style.display = 'none';                  // 部門ラベル
        this.cmb_ClassCode.elementRef.nativeElement.style.display = 'none';       // 部門コンボ
        this.lbl_MiddleClassCode.nativeElement.style.display = 'none';            // 中分類ラベル
        this.cmb_MiddleClassCode.elementRef.nativeElement.style.display = 'none'; // 中分類コンボ
        this.lbl_SmallClassCode.nativeElement.style.display = 'none';             // 小分類ラベル
        this.cmb_SmallClassCode.elementRef.nativeElement.style.display = 'none';  // 小分類コンボ
        this.lbl_PageNo.nativeElement.style.display = '';                         // ページNOラベル
        this.cmb_PageNo.elementRef.nativeElement.style.display = '';              // ページNOコンボ
        this.lbl_buyerCode.nativeElement.style.display = 'none';                  // バイヤーコードラベル
        this.cmb_buyerCode.elementRef.nativeElement.style.display = 'none';       // バイヤーコードコンボ
        this.lbl_OrderClient.nativeElement.style.display = 'none';                // 発注先ラベル
        this.tbx_OrderClientCode.nativeElement.style.display = 'none';            // 発注先取引先コードテキスト
        this.tbx_OrderClientKanji.nativeElement.style.display = 'none';           // 発注先取引先名称テキスト
        this.btn_SearchOrderClient.nativeElement.style.display = 'none';          // 発注先検索ボタン
        this.lbl_PayeeClient.nativeElement.style.display = 'none';                // 支払先ラベル
        this.tbx_PayeeClientCode.nativeElement.style.display = 'none';            // 支払先取引先コードテキスト
        this.tbx_PayeeClientKanji.nativeElement.style.display = 'none';           // 支払先取引先名称テキスト
        this.btn_SearchPayeeClient.nativeElement.style.display = 'none';          // 支払先検索ボタン
        this.selectedModel.kikakuRenrakuStatus = '';                              // 企画連絡ステータス
        break;
      case '3':                                                                   // 「3：バイヤー」の場合
        this.lbl_ClassCode.nativeElement.style.display = 'none';                  // 部門ラベル
        this.cmb_ClassCode.elementRef.nativeElement.style.display = 'none';       // 部門コンボ
        this.lbl_MiddleClassCode.nativeElement.style.display = 'none';            // 中分類ラベル
        this.cmb_MiddleClassCode.elementRef.nativeElement.style.display = 'none'; // 中分類コンボ
        this.lbl_SmallClassCode.nativeElement.style.display = 'none';             // 小分類ラベル
        this.cmb_SmallClassCode.elementRef.nativeElement.style.display = 'none';  // 小分類コンボ
        this.lbl_PageNo.nativeElement.style.display = 'none';                     // ページNOラベル
        this.cmb_PageNo.elementRef.nativeElement.style.display = 'none';          // ページNOコンボ
        this.lbl_buyerCode.nativeElement.style.display = '';                      // バイヤーコードラベル
        this.cmb_buyerCode.elementRef.nativeElement.style.display = '';           // バイヤーコードコンボ
        this.lbl_OrderClient.nativeElement.style.display = '';                    // 発注先ラベル
        this.tbx_OrderClientCode.nativeElement.style.display = '';                // 発注先取引先コードテキスト
        this.tbx_OrderClientKanji.nativeElement.style.display = '';               // 発注先取引先名称テキスト
        this.btn_SearchOrderClient.nativeElement.style.display = '';              // 発注先検索ボタン
        this.lbl_PayeeClient.nativeElement.style.display = '';                    // 支払先ラベル
        this.tbx_PayeeClientCode.nativeElement.style.display = '';                // 支払先取引先コードテキスト
        this.tbx_PayeeClientKanji.nativeElement.style.display = '';               // 支払先取引先名称テキスト
        this.btn_SearchPayeeClient.nativeElement.style.display = '';              // 支払先検索ボタン
        this.selectedModel.kikakuRenrakuStatus = '';                              // 企画連絡ステータス
        break;
      default:
        break;
    }
    // 選定済一覧のグリッドサイズを変更する
    this.resizeFlexGrid();
  }

  /**
   * バンドルミックスマッチ(ボタン)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW1308_CLICKHandler(): void {
    // 『バンドルミックスマッチ設定』画面を呼び出す
    const kymw1308InputVO: KYMW1308InputModel = this.parentModel.setKYMW1308InputVO();

    this.parentModel.kymw1300Component.kymw1308ComponentRef =
      this.dialogService.openModelessSub(this.parentModel.kymw1300Component, KYMW1308Component,
        this.parentModel.kymw1300Component.viewContainerRef, this.parentModel.kymw1300Component.kymw1308ComponentRef, kymw1308InputVO,
        0, '', true);

    if (this.parentModel.kymw1300Component.kymw1308ComponentRef != null) {
      this.parentModel.kymw1300Component.kymw1308cmp =
        this.parentModel.kymw1300Component.kymw1308ComponentRef.instance as KYMW1308Component;
      this.parentModel.kymw1300Component.kymw1308cmp.setInterfaceParam(kymw1308InputVO);
      this.parentModel.kymw1300Component.kymw1308cmp.parent = this.parentModel.kymw1300Component;

      // 設定ボタン押下時の処理
      this.parentModel.kymw1300Component.kymw1308cmp.setKYMW1308Parameter =
        (kymw1308OutputVO: KYMW1308OutputModel) => this.parentModel.kymw1300Component.setKYMW1308Parameter(kymw1308OutputVO);

      // ウィンドウが閉じられる際の処理
      this.parentModel.kymw1300Component.kymw1308cmp.closeFunction = () => {
        this.parentModel.kymw1300Component.kymw1308ComponentRef.destroy();
        this.parentModel.kymw1300Component.kymw1308cmp = null;
      };
    }
  }

  /**
   * 次回案内一括設定(ボタン)_クリック時に呼び出される
   *
   * @returns {void}
   * @memberof KYMW1300SelectedListComponent
   */
  public eventUpdateNextGuideLump_CLICKHandler(): void {
    // ヘッダー情報入力チェック(媒体：チェック否、売り場：チェック否)
    if (!this.parentModel.kymw1300Component.checkInputHeader()) {               // チェックエラーの場合
      return;
    }

    // 12. 次回案内一括設定APIリクエストVO初期化処理
    const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.parentModel.setGetSelectedListVO(true);

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.parentModel.lastTimeGetSelectedListVO = getSelectedListVO;

    // 12. 次回案内一括設定API呼び出し
    this.updateNextGuideLumpService.execute(this.parentModel, getSelectedListVO,
      (data: any) => this.parentModel.kymw1300Component.updateNextGuideLumpServiceSuccessFunc(data, getSelectedListVO));
  }

  /**
   * 次回案内チェック(ボタン)_クリック時に呼び出される
   *
   * @returns {void}
   * @memberof KYMW1300SelectedListComponent
   */
  public eventCheckNextGuide_CLICKHandler(): void {
    // ヘッダー情報入力チェック(媒体：チェック否、売り場：チェック否)
    if (!this.parentModel.kymw1300Component.checkInputHeader()) {               // チェックエラーの場合
      return;
    }

    // 05. 選定済一覧取得APIリクエストVO初期化処理
    const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.parentModel.setGetSelectedListVO(true);
    getSelectedListVO.nextGuideCheckFlg = '1';                                  // 次回案内チェックフラグ(1：チェックする)
    getSelectedListVO.focusFlg = '5';                                           // 次回案内チェックボタン

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.parentModel.lastTimeGetSelectedListVO = getSelectedListVO;

    // 05. 選定済一覧取得API呼び出し
    this.getSelectedListService.execute(this.parentModel, getSelectedListVO,
      (data: any) => this.parentModel.kymw1300Component.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
  }

  /**
   * (選定済一覧)出力(ボタン)_クリック時に呼び出される
   *
   * @returns {void}
   * @memberof KYMW1300SelectedListComponent
   */
  public eventOutputSelectedList_CLICKHandler(): void {
    // ヘッダー情報入力チェック(媒体：チェック否、売り場：チェック否)
    if (!this.parentModel.kymw1300Component.checkInputHeader()) {               // チェックエラーの場合
      return;
    }

    // 15. 選定済一覧出力APIリクエストVO初期化処理
    const vo = {
      dispMode: this.selectedModel.accessDispMode,
      orderCode: this.parentModel.orderCode,
      mediumType: this.parentModel.mediumType,
      sellAreaCode: this.parentModel.kymw1300Component.cmb_SellArea.selectedSellAreaCode,
      orderNumQuotaCode: this.cmb_OrderNumQuota_Selected.selectedOrderNumQuotaCode,
      coopCode: this.cmb_CoopCode.selectedCoopCode,
      classCode: this.cmb_ClassCode.selectedClassCode,
      middleClassCode: this.cmb_MiddleClassCode.selectedMiddleClassCode,
      smallClassCode: this.cmb_SmallClassCode.selectedSmallClassCode,
      pageNo: this.cmb_PageNo.selectedPageNum,
      buyerCode: this.cmb_buyerCode.selectedCodeValue,
      displayItemSetDiv: this.selectedModel.displayItem,
      orderClientCode: this.selectedModel.orderClientCode,
      orderClientKanji: this.selectedModel.orderClientKanji,
      payeeClientCode: this.selectedModel.payeeClientCode,
      payeeClientKanji: this.selectedModel.payeeClientKanji,
    };

    // 受注コードが未入力の場合
    if (PlessViewUtilsSub.isEmpty(vo.orderCode)) {
      vo.orderCode = this.parentModel.startOrderCode;
    }

    // 15. 選定済一覧出力API呼び出し
    this.outputSelectedListService.execute(this.selectedModel, vo,
      (data: any) => this.parentModel.kymw1300Component.outputSelectedListServiceSuccessFunc(data));
  }

  /**
   * 選定済一覧・表示／前へ／次へ(ボタン)_クリック時に呼び出される
   *
   * @param {number} [focusFlg=0] フォーカスフラグ(0：表示ボタン、1：前へボタン、2：次へボタン)
   * @returns {void}
   * @memberof KYMW1300SelectedListComponent
   */
  public eventDisplaySelectedList_CLICKHandler(focusFlg = 0): void {
    // 表示モードのチェック
    if (this.selectedModel.dispMode === '2') {                                  // 「2：ページ」の場合
      // ヘッダー情報入力チェック(媒体：チェック要、売り場：チェック否)
      if (!this.parentModel.kymw1300Component.checkInputHeader(true, false)) { // チェックエラーの場合
        return;
      }

      // 必須チェック：会員生協
      if (PlessViewUtilsSub.isEmpty(this.cmb_CoopCode.selectedCoopCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['会員生協'], () => { });
        return;
      }
    } else {                                                                    // 上記以外の場合
      // ヘッダー情報入力チェック(媒体：チェック否、売り場：チェック否)
      if (!this.parentModel.kymw1300Component.checkInputHeader()) {            // チェックエラーの場合
        return;
      }
    }

    let getSelectedListVO: KYMW1300GetSearchSelectedListModel = null;

    // フォーカスフラグのチェック
    switch (focusFlg) {
      case 0:                                                                   // 「0：表示ボタン」の場合
        // 05. 選定済一覧取得APIリクエストVO初期化処理
        getSelectedListVO = this.parentModel.setGetSelectedListVO();
        getSelectedListVO.focusFlg = String(focusFlg);
        break;
      case 1:                                                                   // 「1：前へボタン」の場合
        // 05. 選定済一覧取得APIリクエストVO初期化処理
        // ページング時は1ページ目の検索条件があれば使用する
        getSelectedListVO = this.parentModel.lastTimeGetSelectedListVO;
        if (!getSelectedListVO) {
          getSelectedListVO = this.parentModel.setGetSelectedListVO(Boolean(true));
        }
        getSelectedListVO.page = String(Number(getSelectedListVO.page) - 1);
        getSelectedListVO.focusFlg = String(focusFlg);
        break;
      case 2:                                                                   // 「2：次へボタン」の場合
        // 05. 選定済一覧取得APIリクエストVO初期化処理
        // ページング時は1ページ目の検索条件があれば使用する
        getSelectedListVO = this.parentModel.lastTimeGetSelectedListVO;
        if (!getSelectedListVO) {
          getSelectedListVO = this.parentModel.setGetSelectedListVO(Boolean(true));
        }
        getSelectedListVO.page = String(Number(getSelectedListVO.page) + 1);
        getSelectedListVO.focusFlg = String(focusFlg);
        break;
      default:
        return;
    }

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.parentModel.lastTimeGetSelectedListVO = getSelectedListVO;

    // 05. 選定済一覧取得API呼び出し
    this.getSelectedListService.execute(this.parentModel, getSelectedListVO,
      (data: any) => this.parentModel.kymw1300Component.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
  }

  /**
   * 選定済一覧・ソート(データグリッドカラム)_クリック時に呼び出される
   *
   * @param {*} event
   * @param {FlexGrid} grid
   * @returns {void}
   * @memberof KYMW1300SelectedListComponent
   */
  public eventSelectedList_HEADERRELEASEHandler(event: any, grid: FlexGrid): void {
    // 後続のデフォルトイベントをキャンセル
    event.preventDefault();

    // クリック個所のチェックCellType
    if (grid.hitTest(event).cellType === CellType.Cell) {                       // セルの場合
      this.parentModel.currentContext = 'selectedList';
      // 子画面の再表示
      this.parentModel.kymw1300Component.refleshTargetWindow();

      // 処理復帰
      return;
    }
    const field: string = this.selectedListField[grid.columns[grid.hitTest(event).col].binding];
    // イベント発生項目のチェック
    if (field === undefined                                                     // ソート対象項目ではない場合
      || PlessViewUtilsSub.isEmpty(field)) {
      // 処理復帰
      return;
    }
    // ソート可否判定処理
    if (!DataGridUtil.isSortable(event, grid)) {                                // ソート不可の場合
      // 処理復帰
      return;
    }
    // 05. 選定済一覧取得APIリクエストVO初期化処理
    const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.parentModel.setGetSelectedListVO(true);
    getSelectedListVO.page = '1';
    getSelectedListVO.sortItem = field;
    getSelectedListVO.sortOrder = DataGridUtil.switchHeaderText(event, grid);

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.parentModel.lastTimeGetSelectedListVO = getSelectedListVO;

    // 05. 選定済一覧取得API呼び出し
    this.getSelectedListService.execute(this.parentModel, getSelectedListVO,
      (data: any) => this.parentModel.kymw1300Component.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
  }

  /**
   * 選定済一覧(データグリッド)_選択アイテム変更時_変更時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventSelected_ITEMCLICKHandler(): void {
    this.parentModel.kymw1300Component.refleshTargetWindow();
  }

  /**
   * (発注先)検索(ボタン)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventSearchOrdrClientHandler(): void {
    const kymw0400InputVO: KYMW0400InputModel = new KYMW0400InputModel();
    kymw0400InputVO.supplierFlg = '0';                                          // 発注先

    const componentRef = this.dialogService.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;
    instance.parent = this.parentModel.kymw1300Component;
    instance.setInterfaceParam(kymw0400InputVO);
    instance.setKYMW0400Parameter =
      (kymw0400OutputVO: KYMW0400OutputModel) => this.parentModel.kymw1300Component.setKYMW0400Parameter(kymw0400OutputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * (支払先)検索(ボタン)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventSearchPayeeHandler(): void {
    // VOに値を設定
    const kymw0400InputVO: KYMW0400InputModel = new KYMW0400InputModel();
    kymw0400InputVO.supplierFlg = '1';                                          // 支払先

    const componentRef = this.dialogService.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;
    instance.parent = this.parentModel.kymw1300Component;
    instance.setInterfaceParam(kymw0400InputVO);
    instance.setKYMW0400Parameter =
      (kymw0400OutputVO: KYMW0400OutputModel) => this.parentModel.kymw1300Component.setKYMW0400Parameter(kymw0400OutputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // コンテキストメニュー クリックイベント処理 START

  /**
   * 商品企画修正(コンテキスト)_クリック時に呼び出される
   *
   * @private
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW0900_CLICKHandler(): void {
    // 商品企画メンテナンス画面InputVO初期化
    const kymw0900VO: KYMW0900InputModel = this.parentModel.setKYMW0900InputVO();

    // 編集ロックのチェック
    if (this.parentModel.editLock) {                                            // 「true：ロック取得済み」の場合
      // 排他ロックを行う
      this.LockUtilForPlanGoods('REGIST',
        kymw0900VO.orderCode, kymw0900VO.MediumType, kymw0900VO.pCodeList[0],
        (successParam: any) => {
          this.parentModel.kymw1300Component.lockOkFunc_KYMW0900(successParam);
        }, kymw0900VO,
        (faultParam: any, result: any) => {
          this.parentModel.kymw1300Component.lockErrFunc_KYMW0900(faultParam, result);
        }, kymw0900VO,
        false);
    } else {                                                                    // 上記以外の場合
      // 商品企画メンテナンス画面InputVO初期化
      kymw0900VO.lockInfo = '1';

      const componentRef = this.dialogService.openModal(KYMW0900Component);
      const instance = componentRef.componentInstance as KYMW0900Component;
      instance.parent = this.parentModel.kymw1300Component;
      instance.setInterfaceParam(kymw0900VO);
      instance.setKYMW0900Parameter =
        (kymw0900OutputVO: KYMW0900OutputModel) => this.parentModel.kymw1300Component.setKYMW0900Parameter(kymw0900OutputVO);
      instance.closeFunction = () => {
        componentRef.close();
      };
    }
  }

  /**
   * 紐付設定(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW0500_CLICKHandler(): void {
    // 紐付設定画面InputVO初期化
    const kymw0500InputVO: KYMW0500InputModel = this.parentModel.setKYMW0500InputVO();

    const componentRef = this.dialogService.openModal(KYMW0500Component);
    const instance = componentRef.componentInstance as KYMW0500Component;
    instance.parent = this.parentModel.kymw1300Component;
    instance.setInterfaceParam(kymw0500InputVO);
    instance.setKYMW0500Parameter =
      (kymw0500OutputVO: KYMW0500OutputModel) => this.parentModel.kymw1300Component.setKYMW0500Parameter(kymw0500OutputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * バンドルミックスマッチ設定(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW1308_MOD_CLICKHandler(): void {
    const kymw1308InputVO: KYMW1308InputModel = new KYMW1308InputModel();
    kymw1308InputVO.accessDiv = '1';                                            // 処理区分(1：バンドルミックスマッチ設定)
    kymw1308InputVO.editLock = this.parentModel.kymw1300Component.getIcnEditLock();
    kymw1308InputVO.orderCode = this.parentModel.orderCode;
    kymw1308InputVO.mediumType = this.parentModel.mediumType;
    kymw1308InputVO.pCodeList = new Array<any>();
    kymw1308InputVO.pCodeList.push(this.parentModel.targetPCode);
    kymw1308InputVO.promotionNo = this.parentModel.getPromotionInfo(this.parentModel.targetPCode);

    if (this.parentModel.kymw1300Component.kymw1308cmp == null) {

      this.parentModel.kymw1300Component.kymw1308ComponentRef =
        this.dialogService.openModelessSub(this.parentModel.kymw1300Component, KYMW1308Component,
          this.parentModel.kymw1300Component.viewContainerRef, this.parentModel.kymw1300Component.kymw1308ComponentRef, kymw1308InputVO, 0, '', true);
      if (this.parentModel.kymw1300Component.kymw1308ComponentRef != null) {
        this.parentModel.kymw1300Component.kymw1308cmp =
          this.parentModel.kymw1300Component.kymw1308ComponentRef.instance as KYMW1308Component;
        this.parentModel.kymw1300Component.kymw1308cmp.setInterfaceParam(kymw1308InputVO);
        this.parentModel.kymw1300Component.kymw1308cmp.parent = this.parentModel.kymw1300Component;

        // 設定ボタン押下時の処理
        this.parentModel.kymw1300Component.kymw1308cmp.setKYMW1308Parameter =
          (kymw1308OutputVO: KYMW1308OutputModel) => this.parentModel.kymw1300Component.setKYMW1308Parameter(kymw1308OutputVO);

        // ウィンドウが閉じられる際の処理
        this.parentModel.kymw1300Component.kymw1308cmp.closeFunction = () => {
          this.parentModel.kymw1300Component.kymw1308ComponentRef.destroy();
          this.parentModel.kymw1300Component.kymw1308cmp = null;
        };
      }
    } else {

      this.parentModel.kymw1300Component.kymw1308cmp.setInputVO(kymw1308InputVO);
    }
  }

  /**
   * セット企画設定(コンテキスト)_クリック時に呼び出される
   *
   * @returns {void}
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW1312_MOD_CLICKHandler(): void {
    // セット企画設定画面の起動状況のチェック
    if (!this.isOpened('KYMW1312')) {                                           // 未起動の場合
      // セット企画設定画面起動処理
      this.openPromotionSetGoodsModClick(PlessAlert.Yes);

      // 処理復帰
      return;
    }

    // 編集状況のチェック
    if (this.parentModel.kymw1300Component.kymw1312cmp.editCount > 0) {        // 編集中の場合
      // 確認メッセージ表示(変更内容を破棄)
      this.dialogService.openAlertGetMessage('Q0107', ['セット企画プロモーション情報'],
        (detail: number) => this.openPromotionSetGoodsModClick(detail));
    } else {
      // 『セット企画設定』画面を呼び出す
      this.openPromotionSetGoodsModClick(PlessAlert.Yes);
    }
  }

  /**
   * セット企画設定(コンテキスト)_クリック時に『セット企画設定』画面を呼び出す処理
   *
   */
  /**
   * セット企画設定画面起動
   * セット企画設定(コンテキスト)_クリック時にセット企画設定画面を呼び出す処理
   *
   * @param {number} detail
   * @memberof KYMW1300SelectedListComponent
   */
  public openPromotionSetGoodsModClick(detail: number): void {
    if (detail === PlessAlert.Yes) {
      // 『セット企画設定』画面を呼び出す
      const kymw1312InputVO: KYMW1312InputModel = this.parentModel.setKYMW1312InputVO('1');

      this.parentModel.kymw1300Component.kymw1312ComponentRef =
        this.dialogService.openModelessSub(this.parentModel.kymw1300Component, KYMW1312Component,
          this.parentModel.kymw1300Component.viewContainerRef, this.parentModel.kymw1300Component.kymw1312ComponentRef, kymw1312InputVO, 1, '', true);

      if (this.parentModel.kymw1300Component.kymw1312ComponentRef != null) {
        this.parentModel.kymw1300Component.kymw1312cmp =
          this.parentModel.kymw1300Component.kymw1312ComponentRef.instance as KYMW1312Component;
        this.parentModel.kymw1300Component.kymw1312cmp.setInterfaceParam(kymw1312InputVO);
        this.parentModel.kymw1300Component.kymw1312cmp.parent = this.parentModel.kymw1300Component;

        // 設定ボタン押下時の処理
        this.parentModel.kymw1300Component.kymw1312cmp.setKYMW1312Parameter =
          (kymw1312OutputVO: KYMW1312OutputModel) => this.parentModel.kymw1300Component.setKYMW1312Parameter(kymw1312OutputVO);

        // ウィンドウが閉じられる際の処理
        this.parentModel.kymw1300Component.kymw1312cmp.closeFunction = () => {
          this.parentModel.kymw1300Component.kymw1312ComponentRef.destroy();
          this.parentModel.kymw1300Component.kymw1312cmp = null;
        };
      }
    }
  }

  /**
   * Ｗ掲載設定(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW1310_CLICKHandler(): void {
    const kymw1310InputVO: KYMW1310InputModel = this.parentModel.setKYMW1310InputVO();

    // ロック状況の確認
    if (kymw1310InputVO.editLock                                                // ロック取得
      && PlessViewUtilsSub.isEmpty(this.parentModel.lockPCode)) {               // Ｐコード指定なしの場合
      // 企画商品ロック(REGIST：ロック登録)
      this.LockUtilForPlanGoods('REGIST',
        kymw1310InputVO.orderCode, this.dg_SelectedItemList.selectedItems[0].MediumType, kymw1310InputVO.pCode,
        (successParam: any) => {
          this.parentModel.kymw1300Component.lockOkFunc_KYMW1310(successParam);
        }, kymw1310InputVO,
        (faultParam: any, result: any) => {
          this.parentModel.kymw1300Component.lockErrFunc_KYMW1310(faultParam, result);
        }, kymw1310InputVO,
        false);
    } else {                                                                     // 上記以外の場合
      // Ｗ掲載設定画面(モーダレス)を表示する。
      this.parentModel.kymw1300Component.kymw1310ComponentRef =
        this.dialogService.openModelessSub(this.parentModel.kymw1300Component, KYMW1310Component,
          this.parentModel.kymw1300Component.viewContainerRef, this.parentModel.kymw1300Component.kymw1310ComponentRef, kymw1310InputVO, 0, '', true);

      if (this.parentModel.kymw1300Component.kymw1310ComponentRef != null) {
        this.parentModel.kymw1300Component.kymw1310cmp =
          this.parentModel.kymw1300Component.kymw1310ComponentRef.instance as KYMW1310Component;
        this.parentModel.kymw1300Component.kymw1310cmp.setInterfaceParam(kymw1310InputVO);
        this.parentModel.kymw1300Component.kymw1310cmp.parent = this.parentModel.kymw1300Component;
        this.parentModel.kymw1300Component.kymw1310cmp.setKYMW1310Parameter
          = () => this.parentModel.kymw1300Component.setKYMW1310Parameter();

        // ウィンドウが閉じられる際の処理
        this.parentModel.kymw1300Component.kymw1310cmp.closeFunction = () => {
          // 子画面close時の排他RELEASE処理
          this.parentModel.kymw1300Component.kymw1310ComponentRef.destroy();
          this.parentModel.kymw1300Component.kymw1310cmp = null;
          this.parentModel.kymw1300Component.checkLockChildClose();
        };
      }
    }
  }

  /**
   * バンドルミックスマッチに追加(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW1308_ADD_CLICKHandler(): void {
    const kymw1308InputVO: KYMW1308InputModel = new KYMW1308InputModel();
    kymw1308InputVO.accessDiv = '2';                                            // 処理区分(2：バンドルミックスマッチ追加)
    kymw1308InputVO.pCodeList = new Array<any>();

    for (const item of this.dg_SelectedItemList.selectedItems) {
      kymw1308InputVO.pCodeList.push(item.PCode);
    }

    this.parentModel.kymw1300Component.kymw1308cmp.setInputVO(kymw1308InputVO);
  }

  /**
   * セット企画に追加(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW1312_ADD_CLICKHandler(): void {
    const kymw1312InputVO: KYMW1312InputModel = new KYMW1312InputModel();
    kymw1312InputVO.accessDiv = '2';                                            // 処理区分(2：セット企画追加)
    kymw1312InputVO.editLock = true;
    kymw1312InputVO.orderCode = this.parentModel.orderCode;
    kymw1312InputVO.pCodeList = new Array<any>();

    for (const item of this.dg_SelectedItemList.selectedItems) {
      kymw1312InputVO.pCodeList.push(item.PCode);
    }

    if (this.isOpened('KYMW1312')) {
      kymw1312InputVO.editCount = Number(1);
    }
    kymw1312InputVO.isGroupNormal = this.parentModel.kymw1300Component.kymw1300Model.isGroupNormal();

    this.parentModel.kymw1300Component.kymw1312cmp.setInputVO(kymw1312InputVO);
  }

  /**
   * 次回案内自動設定(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventNextGuideSet_CLICKHandler(): void {
    // 11. 次回案内自動設定APIリクエストVO初期化処理
    const updateNextGuideAutoVO: KYMW1300UpdateNextGuideAutoModel = this.parentModel.setUpdateNextGuideAutoVO();

    // 11. 次回案内自動設定API呼び出し
    this.updateNextGuideAutoService.execute(this.parentModel, updateNextGuideAutoVO,
      (data: any) => this.parentModel.kymw1300Component.updateNextGuideAutoServiceSuccessFunc(data));
  }

  /**
   * 履歴・選定済一覧(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW0800Selected_CLICKHandler(): void {
    const fromSelectedList = 'selectedList';

    const kymw0800vo: KYMW0800InputModel = this.parentModel.setKYMW0800InputVO(fromSelectedList);

    // 編集ロック、イベント発生データグリッドのチェック
    if (this.parentModel.editLock                                               // 「true：ロック取得済み」、
      ) {                                                      // 選定済一覧の場合
      // 排他ロックを行う
      this.LockUtilForPlanGoods('REGIST',
        kymw0800vo.orderCode, kymw0800vo.mediumType, kymw0800vo.pCodeList[0].PCode,
        (successParam: any) => {
          this.parentModel.kymw1300Component.lockOkFunc_KYMW0800(successParam);
        }, kymw0800vo,
        (faultParam: any, result: any) => {
          this.parentModel.kymw1300Component.lockErrFunc_KYMW0800(faultParam, result);
        },
        kymw0800vo,
        false);
    } else {                                                                    // 上記以外の場合
      kymw0800vo.funcID = 'KYMW1300L';

      this.parentModel.kymw1300Component.kymw0800ComponentRef =
        this.dialogService.openModelessSub(this.parentModel.kymw1300Component, KYMW0800Component,
          this.parentModel.kymw1300Component.viewContainerRef, this.parentModel.kymw1300Component.kymw0800ComponentRef, kymw0800vo, null, '', true);
      if (this.parentModel.kymw1300Component.kymw0800ComponentRef != null) {
        this.parentModel.kymw1300Component.kymw0800cmp =
          this.parentModel.kymw1300Component.kymw0800ComponentRef.instance as KYMW0800Component;
        this.parentModel.kymw1300Component.kymw0800cmp.setInterfaceParam(kymw0800vo);
        this.parentModel.kymw1300Component.kymw0800cmp.parent = this.parentModel.kymw1300Component;
        this.parentModel.kymw1300Component.kymw0800cmp.setKYMW0800Parameter
          = (outputVO: KYMW0800OutputModel) => this.parentModel.kymw1300Component.setKYMW0800Parameter(outputVO);

        // ウィンドウが閉じられる際の処理
        this.parentModel.kymw1300Component.kymw0800cmp.closeFunction = () => {
          // 子画面close時の排他RELEASE処理
          this.parentModel.kymw1300Component.kymw0800ComponentRef.destroy();
          this.parentModel.kymw1300Component.kymw0800cmp = null;
          this.parentModel.kymw1300Component.checkLockChildClose();
        };
      }
    }
  }

  /**
   * 予算・計画・実績表(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW1307_CLICKHandler(): void {
    const kymw1307vo: KYMW1307InputModel = this.parentModel.setKYMW1307InputVO();

    // 予算・計画・実績表画面を呼び出す
    this.parentModel.kymw1300Component.kymw1307ComponentRef =
      this.dialogService.openModelessSub(this.parentModel.kymw1300Component, KYMW1307Component,
        this.parentModel.kymw1300Component.viewContainerRef, this.parentModel.kymw1300Component.kymw1307ComponentRef, kymw1307vo, 0, '', true);

    if (this.parentModel.kymw1300Component.kymw1307ComponentRef != null) {
      this.parentModel.kymw1300Component.kymw1307cmp =
        this.parentModel.kymw1300Component.kymw1307ComponentRef.instance as KYMW1307Component;
      this.parentModel.kymw1300Component.kymw1307cmp.setInterfaceParam(kymw1307vo);
      this.parentModel.kymw1300Component.kymw1307cmp.parent = this.parentModel.kymw1300Component;

      // ウィンドウが閉じられる際の処理
      this.parentModel.kymw1300Component.kymw1307cmp.closeFunction = () => {
        this.parentModel.kymw1300Component.kymw1307ComponentRef.destroy();
        this.parentModel.kymw1300Component.kymw1307cmp = null;
      };
    }
  }

  /**
   * 仕様確認表出力(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventOutputSpecConfirmList_CLICKHandler(): void {
    // 17. 仕様確認表出力APIリクエストVO初期化処理
    const vo = {
      orderCode: this.parentModel.orderCode,
      pCodeList: []
    };

    // 選定済一覧で選択行のＰコードを取得する
    for (const item of this.dg_SelectedItemList.selectedItems) {
      vo.pCodeList.push(item.PCode);
    }

    // 17. 仕様確認表出力API呼び出し
    this.outputSpecConfirmListService.execute(this.selectedModel, vo,
      (data: any) => this.parentModel.kymw1300Component.outputSpecConfirmListServiceSuccessFunc(data));
  }

  /**
   * 選定解除(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventDeletePlan_CLICKHandler(): void {
    // 09. 選定解除確認APIリクエストVO初期化処理
    const deletePlanVO: KYMW1300DeletePlanModel = this.parentModel.setDeletePlanVO();

    // 09. 選定解除確認API呼び出し
    this.checkDeletePlanService.execute(this.parentModel, deletePlanVO,
      (data: any) => this.parentModel.kymw1300Component.checkDeletePlanServiceSuccessFunc(data, deletePlanVO));
  }

  /**
   * 企画連絡承認_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public eventKYMW1317_CLICKHandler(): void {
    // 企画連絡承認画面InputVO初期化
    const kymw1317VO: KYMW1317InputModel = this.parentModel.setKYMW1317InputVO();

    // 編集ロックのチェック
    if (this.parentModel.editLock) {
      // 排他ロックを行う
      this.LockUtilForPlanGoods('REGIST',
        kymw1317VO.orderCode, kymw1317VO.MediumType, kymw1317VO.pCodeList[0],
        (successParam: any) => {
          this.parentModel.kymw1300Component.lockOkFunc_KYMW1317(successParam);
        }, kymw1317VO,
        (faultParam: any, result: any) => {
          this.parentModel.kymw1300Component.lockErrFunc_KYMW1317(faultParam, result);
        }, kymw1317VO, false);
    } else {                                                                    // 上記以外の場合
      // 企画連絡承認画面InputVO初期化
      kymw1317VO.lockInfo = '1';
      const componentRef = this.dialogService.openModal(KYMW1317Component);
      const instance = componentRef.componentInstance as KYMW1317Component;
      instance.parent = this.parentModel.kymw1300Component;
      instance.setInterfaceParam(kymw1317VO);
      instance.setKYMW1317Parameter =
        (kymw1317OutputVO: KYMW1317OutputModel) => this.parentModel.kymw1300Component.setKYMW1317Parameter(kymw1317OutputVO);
      instance.closeFunction = () => {
        componentRef.close();
      };
    }
  }

  /**
   *  特集付替設定_クリック時に呼び出される
   *
   * @memberof KYMW1300SelectedListComponent
   */
  public async eventKYMW1319_CLICKHandler(): Promise<void> {
    //「受注コード」「束ね企画の開始受注コード」の入力チェック
    if (PlessViewUtilsSub.isEmpty(this.parentModel.orderCode) && PlessViewUtilsSub.isEmpty(this.parentModel.bundleCatalogGuideStandardName)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード、束ね企画名どちらか']);
      return
    }
    // 「受注コード」の存在チェック
    if (!PlessViewUtilsSub.isEmpty(this.parentModel.orderCode) && !this.parentModel.kymw1300Component.txt_OrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('W0024', ['受注コード']);
      return
    }

    // 特集付替設定画面InputVO初期化
    const kymw1319VO = this.parentModel.setKYMW1319InputVO();

    // 特集付替設定画面 呼び出し
    const componentRef = this.dialogService.openModal(KYMW1319Component);
    const instance = componentRef.componentInstance as KYMW1319Component;
    instance.parent = this.parentModel.kymw1300Component;
    instance.setInterfaceParam(kymw1319VO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }
  // コンテキストメニュー クリックイベント処理 END

  /**
   * データグリッド「選定済一覧」のキー項目を指定し該当行を選択状態にする。
   *
   * @param {string} targetPCode 選択対象Ｐコード
   * @param {boolean} [scrollFlg=false] スクロールフラグ(true：スクロール要、false：スクロール否)
   * @memberof KYMW1300SelectedListComponent
   */
  public selectRowSelected(targetPCode: string,
    scrollFlg = false,
    vo: KYMW1300GetSearchSelectedListModel,
    func: Function): void {
    setTimeout(() => {
      // 行選択・スクロール処理
      for (let i = Number(0); i < this.selectedModel.selectedList.length; i++) {

        // Ｐコードの比較
        if (this.selectedModel.selectedList[i].PCode === targetPCode) {           // 同一Ｐコードの場合
          // 選択行を設定
          this.dg_SelectedItemList.select(i, -1);

          // スクロールフラグのチェック
          if (scrollFlg) {                                                        // スクロール要の場合
            // スクロール位置を設定
            const rc = this.dg_SelectedItemList.cells.getCellBoundingRect(i, 0, true);
            this.dg_SelectedItemList.scrollPosition = new Point(0, -rc.top);
          }

          // ループ中断
          break;
        }
      }

      // 後続処理を呼び出す
      func(vo);
    });
  }

  // ロード完了通知 START
  /**
   * 注文コード割当コードコンボロード完了通知
   *
   * @param {string} code 選択注文コード割当コード
   * @memberof KYMW1300SelectedListComponent
   */
  public orderNumQuotaLoadCompleted(code: string): void {
    this.selectedModel.orderNumQuotaCode = code;
    this.cmb_OrderNumQuota_Selected.selectedOrderNumQuotaCode = code;
  }
  // ロード完了通知 END

  /**
   * 一覧表の高さ調整
   * @returns
   */
  public resizeFlexGrid(): void {
    // 表示切替が選定候補一覧＆選定済一覧の場合
    if (this.parentModel.cntDispChange === 1) {
      switch (this.selectedModel.dispMode) {
        case '1':                                                                   // 「1：部門」の場合
          this.dg_SelectedItemList.hostElement.style.height = 'calc(-400px + 50vh)';
          return;
        case '2':                                                                   // 「2：ページ」の場合
          this.dg_SelectedItemList.hostElement.style.height = 'calc(-400px + 50vh)';
          return;
        case '3':                                                                   // 「3：バイヤー」の場合
          this.dg_SelectedItemList.hostElement.style.height = 'calc(-400px + 50vh)';
          return;
      }
    }
    // 表示切替が選定済一覧の場合
    switch (this.selectedModel.dispMode) {
      case '1':                                                                   // 「1：部門」の場合
        this.dg_SelectedItemList.hostElement.style.height = 'calc(-400px + 100vh)';
        return;
      case '2':                                                                   // 「2：ページ」の場合
        this.dg_SelectedItemList.hostElement.style.height = 'calc(-400px + 100vh)';
        return;
      case '3':                                                                   // 「3：バイヤー」の場合
        this.dg_SelectedItemList.hostElement.style.height = 'calc(-400px + 100vh)';
        return;
    }
  }

  /**
 * pagerコンポーネント内で前へボタンの前の遷移先を1300コンポーネントにて指定するために使用するコールバック関数
 * @returns 
 */
  public getPrevFunctionChangeTab(): CallableFunction {
    return () => {
      this.cmb_DisplaySet.nativeElement.focus();
    };
  }

  /**
   * Tabキーによるフォーカス移動
   * タブパネルの最後の項目→次のタブパネルの先頭の項目
   *
   * @param {*} event
   * @memberof KYMW1300TargetListComponent
   */
  public nextFocus(event: any): void {
    // キーコードのチェック
    if (event.keyCode === 9 && !event.shiftKey) {
      // 活性状態のチェック        
      if (!this.selectedPager.btnPrev.nativeElement.classList.contains('disabled')) {
        this.selectedPager.btnPrev.nativeElement.focus();
        event.preventDefault();
        return;
      }
      if (!this.selectedPager.btnNext.nativeElement.classList.contains('disabled')) {
        this.selectedPager.btnNext.nativeElement.focus();
        event.preventDefault();
        return;
      }
    }
  }
}
